export const TRANSACTION_KINDS = {
  EXPENSE: "expense",
  INCOME: "income",
  TRANSFER: "transfer",
  DETAILED: "detailed",
  BALANCE_ADJUSTMENT: "balance_adjustment",
  CREDIT_CARD_CHARGE: "credit_card_charge",
  CREDIT_CARD_INVOICE: "credit_card_invoice",
};

export const CATEGORY_TYPES = {
  EXPENSE: "expense",
  INCOME: "income",
  TRANSFER: "transfer",
};

export function getCategoryTypeForTransactionKind(kind) {
  if (kind === TRANSACTION_KINDS.INCOME) return CATEGORY_TYPES.INCOME;
  if (kind === TRANSACTION_KINDS.TRANSFER) return CATEGORY_TYPES.TRANSFER;
  return CATEGORY_TYPES.EXPENSE;
}

export function isTransferTransaction(transaction = {}) {
  return transaction.transaction_kind === TRANSACTION_KINDS.TRANSFER || Boolean(transaction.linked_transfer_id);
}

export function isDetailedTransaction(transaction = {}) {
  return transaction.transaction_kind === TRANSACTION_KINDS.DETAILED;
}

export function isCreditCardCharge(transaction = {}) {
  return transaction.transaction_kind === TRANSACTION_KINDS.CREDIT_CARD_CHARGE;
}

export function isCreditCardInvoice(transaction = {}) {
  return transaction.transaction_kind === TRANSACTION_KINDS.CREDIT_CARD_INVOICE;
}

function normalizeToken(value) {
  return String(value || "").trim().toLocaleUpperCase("pt-BR");
}

export function isLegacyBalanceAdjustment(transaction = {}) {
  return (
    String(transaction.description || "").trim() === "Ajuste de Saldo" &&
    normalizeToken(transaction.category) === "AJUSTE"
  );
}

export function isBalanceAdjustmentTransaction(transaction = {}) {
  return transaction.transaction_kind === TRANSACTION_KINDS.BALANCE_ADJUSTMENT ||
    isLegacyBalanceAdjustment(transaction);
}

export function getTransactionKind(transaction = {}) {
  if (isBalanceAdjustmentTransaction(transaction)) return TRANSACTION_KINDS.BALANCE_ADJUSTMENT;
  if (isCreditCardCharge(transaction)) return TRANSACTION_KINDS.CREDIT_CARD_CHARGE;
  if (isCreditCardInvoice(transaction)) return TRANSACTION_KINDS.CREDIT_CARD_INVOICE;
  if (isTransferTransaction(transaction)) return TRANSACTION_KINDS.TRANSFER;
  if (isDetailedTransaction(transaction)) return TRANSACTION_KINDS.DETAILED;
  return transaction.type === TRANSACTION_KINDS.INCOME
    ? TRANSACTION_KINDS.INCOME
    : TRANSACTION_KINDS.EXPENSE;
}

export function getTransactionKindLabel(transactionOrKind = {}) {
  const kind = typeof transactionOrKind === "string"
    ? transactionOrKind
    : getTransactionKind(transactionOrKind);

  if (kind === TRANSACTION_KINDS.INCOME) return "Receita";
  if (kind === TRANSACTION_KINDS.TRANSFER) return "Transferência";
  if (kind === TRANSACTION_KINDS.DETAILED) return "Detalhado";
  if (kind === TRANSACTION_KINDS.BALANCE_ADJUSTMENT) return "Ajuste de saldo";
  if (kind === TRANSACTION_KINDS.CREDIT_CARD_CHARGE) return "Despesa de cartão";
  if (kind === TRANSACTION_KINDS.CREDIT_CARD_INVOICE) return "Fatura de cartão";
  return "Despesa";
}

export function isIncomeForReports(transaction = {}) {
  return !isTransferTransaction(transaction) &&
    !isBalanceAdjustmentTransaction(transaction) &&
    !isCreditCardCharge(transaction) &&
    transaction.type === TRANSACTION_KINDS.INCOME;
}

export function isExpenseForReports(transaction = {}) {
  return !isTransferTransaction(transaction) &&
    !isBalanceAdjustmentTransaction(transaction) &&
    !isCreditCardCharge(transaction) &&
    transaction.type === TRANSACTION_KINDS.EXPENSE;
}

export function getTransferAccounts(transaction = {}, linkedTransaction = null) {
  if (!isTransferTransaction(transaction)) {
    return { fromAccount: null, toAccount: null };
  }

  const fromAccount = transaction.from_account
    || linkedTransaction?.from_account
    || (transaction.type === TRANSACTION_KINDS.EXPENSE ? transaction.account : linkedTransaction?.account);
  const toAccount = transaction.to_account
    || linkedTransaction?.to_account
    || (transaction.type === TRANSACTION_KINDS.INCOME ? transaction.account : linkedTransaction?.account);

  return { fromAccount, toAccount };
}
